var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("no-ssr", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.OfflineOnly,
            expression: "OfflineOnly"
          }
        ],
        staticClass: "offline-badge fixed p10 bg-cl-th-error cl-white center-xs"
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("You are offline. Some features might not be available.")
            ) +
            "\n  "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }